import { useEffect } from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  Typography,
  message,
  Card,
  Tabs,
} from "antd";
import { css } from "@emotion/css";
import { useDispatch, useSelector } from "react-redux";
import { NavLink as Link, useNavigate } from "react-router-dom";
//Action
import { sharedLoginAction } from "../store/action/shared/authAction";
import { keyframes } from "emotion";
import LoginCard from "./LoginCard";
import LoginEmailCard from "./LoginEmailCard";
import LoginPhoneCard from "./LoginPhoneCard";
import OTPIcon from "../Icons/OTPIcon";
import PhoneIcon from "../Icons/PhoneIcon";
import EmailIcon from "../Icons/EmailIcon";
import {
  getAllowedAppsAction,
  getCompanyAppsAction,
} from "../store/action/admin/companyAction";

const { Title, Text } = Typography;
const fadeInAndFloat = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatingAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const cardStyle = css`
  animation: ${fadeInAndFloat} 1s forwards,
    ${floatingAnimation} 3s ease-in-out infinite;
`;

function AllLoginCard() {
  const router = useNavigate();
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { loading, error, sharedUserInfo } = sharedLogin;
  const dispatch = useDispatch();

  const sendOtpForgetPassword = useSelector(
    (state) => state.sendOtpForgetPassword
  );
  const { sendOtpForgetPasswordInfo } = sendOtpForgetPassword;
  const changingTokenList = useSelector((state) => state.changingTokenList);
  const { tokenLoginInfo, tokenLoginError } = changingTokenList;
  const themeDefault = useSelector((state) => state.themeDefault);
  useEffect(() => {
    if (tokenLoginError != null) {
      if (sharedUserInfo && sharedUserInfo?.payload) {
        dispatch(getCompanyAppsAction());
        // dispatch(getAllowedAppsAction());
        let companyId =
          sharedUserInfo?.empCompanies &&
          sharedUserInfo?.empCompanies[0]?.companyId?._id;
        if (
          sharedUserInfo &&
          sharedUserInfo?.payload?.email &&
          sharedUserInfo?.payload?.type === "Kiosk" &&
          sharedUserInfo?.payload?.emailVerification === true
        ) {
          if (sharedUserInfo?.empCompanies.length !== 0) {
            router(`/kiosk/qr-code`, { replace: true });
          }
        } else if (
          sharedUserInfo &&
          sharedUserInfo?.payload?.email &&
          sharedUserInfo?.payload?.type === "user" &&
          sharedUserInfo?.payload?.emailVerification === true
        ) {
          if (
            sharedUserInfo?.empCompanies.length === 0 ||
            sharedUserInfo?.empCompanies.length > 1
          ) {
            router("/company/", { replace: true });
          } else {
            router(`/dashboard/`, { replace: true });
          }
        } else if (
          sharedUserInfo &&
          sharedUserInfo?.payload?.email &&
          sharedUserInfo?.payload?.type === "admin"
        ) {
          if (
            sharedUserInfo?.payload?.company &&
            sharedUserInfo?.payload?.planSub
          ) {
            router("/dashboard/", { replace: true });
          } else {
            if (sharedUserInfo?.payload?.company) {
              router("/admin/onboarding");
            } else {
              router("/admin/company-setup");
            }
          }
        } else if (
          sharedUserInfo &&
          sharedUserInfo?.payload?.email &&
          sharedUserInfo?.payload?.emailVerification === true
        ) {
          router(`/dashboard/`, {
            replace: true,
          });
        }
        //super admin work
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedUserInfo]);
  const items = [
    {
      key: "1",
      label: (
        <p
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <EmailIcon style={{ marginRight: "6px" }} /> Login via Email
        </p>
      ),
      children: <LoginCard />,
    },
    {
      key: "2",
      label: (
        <p
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PhoneIcon style={{ marginRight: "6px" }} /> Login via Phone
        </p>
      ),
      children: <LoginPhoneCard />,
    },
    {
      key: "3",
      label: (
        <p
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <OTPIcon style={{ marginRight: "6px" }} /> Login via OTP
        </p>
      ),
      children: <LoginEmailCard />,
    },
  ];
  return (
    <>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Col xs={24} style={{ maxWidth: "540px" }}>
          <Card
            className={cardStyle}
            style={{
              borderRadius: "32px",
              padding: "30px",
            }}
            bodyStyle={{ height: "100%" }}
          >
            <Row gutter={[16, 16]} style={{ height: "100%", display: "flex" }}>
              <Col
                span={24}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <img src="/logo192.png" width={50} />
                <Title level={3}>Sign in</Title>
              </Col>
              <Col
                span={24}
                className={css`
                  .ant-tabs-tab-btn {
                    font-size: 12px;
                  }
                `}
              >
                <Tabs
                  size="small"
                  defaultActiveKey="1"
                  style={{ fontSize: "10px" }}
                  items={items}
                  centered
                />
                {/* <Text style={{ fontSize: 14, fontWeight: 600 }}>
                  Don't have an account?{" "}
                  <Link to="/apps/signup">
                    <span
                      style={{
                        color: `${themeDefault?.info?.colorPrimary} important`,
                      }}
                    >
                      {" "}
                      Signup for free!
                    </span>
                  </Link>
                </Text> */}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default AllLoginCard;
